import { Route } from '@angular/router';
import { orgAuthGuard } from './core/auth/org-auth.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    canActivate: [orgAuthGuard],
    loadChildren: () =>
      import('@org/feature-dashboard').then(m => m.dashboardRoutes),
  },
  {
    path: 'candidates',
    canActivate: [orgAuthGuard],
    loadChildren: () =>
      import('@org/feature-applicants').then(m => m.applicantsRoutes),
  },
  {
    path: 'candidate/:id',
    canActivate: [orgAuthGuard],
    loadComponent: () =>
      import('@org/feature-applicants').then(m => m.CandidateProfile),
  },
  {
    path: 'backfill',
    canActivate: [orgAuthGuard],
    loadChildren: () =>
      import('@org/feature-backfill').then(m => m.backfillRoutes),
  },
  {
    path: 'campaigns',
    canActivate: [orgAuthGuard],
    loadChildren: () =>
      import('@org/feature-marketing').then(m => m.marketingRoutes),
  },
  // Legacy path — the feature was originally called 'marketing' in URLs
  // before the rename to 'campaigns'. Prefix match (the router default)
  // preserves any trailing segments, so /marketing/foo redirects cleanly
  // to /campaigns/foo. pathMatch: 'full' would have caught only the bare
  // /marketing path and let any child deep links fall through.
  { path: 'marketing', redirectTo: 'campaigns' },
  {
    path: 'jobs',
    canActivate: [orgAuthGuard],
    loadChildren: () =>
      import('@org/feature-jobs').then(m => m.jobsRoutes),
  },
  {
    path: 'team',
    canActivate: [orgAuthGuard],
    loadComponent: () =>
      import('@org/feature-team').then(m => m.TeamPage),
  },
  {
    path: 'pipeline-templates',
    canActivate: [orgAuthGuard],
    loadComponent: () =>
      import('@org/feature-pipeline-templates').then(m => m.PipelineTemplatesPage),
  },
  {
    path: 'tasks',
    canActivate: [orgAuthGuard],
    loadChildren: () =>
      import('@org/feature-tasks').then(m => m.featureTasksRoutes),
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
